module.exports = __webpack_public_path__ + "lp/img/background-icn-blue.dfd4b8fd.svg";